import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'
import {keyBy, values} from 'lodash'

export function pending(state) {
  return {
    ...state,
    isLoadingTermine: true,
  }
}

export function fulfilled(state, payload, result) {
  let stateMap = keyBy(state.versetzungsplaene, 'userId')
  result.forEach(item => {
    const userId = item.userId
    let existing = stateMap[userId]
    if (existing) {
      stateMap[userId] = {
        ...existing,
        termine: item.termine,
      }
    } else {
      stateMap[userId] = item
    }
  })
  return {
    ...state,
    versetzungsplaene: values(stateMap),
    isLoadingTermine: false,
  }
}

export function rejected(state) {
  return {
    ...state,
    isLoadingTermine: false,
  }
}

export async function action(payload, state) {
  try {
    return await Api.readVersetzungsplanTermine(
      state.azubiIdsToLoadTermine ? state.azubiIdsToLoadTermine.join(',') : '',
    )
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
